import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';
import { Observable } from 'rxjs';

/**
 * Definição da classe.
 */
@Injectable()
export class PlanoService {

    /**
     * URL da api.
     */
    private baseUrl: string = AppConfig.API_URL + '/plano';

    /**
     * Construtor.
     */
    constructor(private http: HttpClient) { }

    /**
     * Salvar um módulo.
     */
    public savePlano(modulo): any {
        return this.http.post(this.baseUrl, modulo);
    }

    /**
     * Atualizar um módulo.
     */
    public updatePlano(modulo): any {
        return this.http.put(this.baseUrl, modulo);
    }

    /**
     * Deletar por id.
     */
    public delete(id): any {
        return this.http.delete(this.baseUrl + '/' + id);
    }

    /**
     * Busca por id.
     */
    public findById(id): any {
        return this.http.get(this.baseUrl + '/' + id);
    }

    /**
     * buscar todos os formulários.
     */
    public findAll(): any {
        return this.http.get(this.baseUrl);
    }

    /**
   * Busca os lancamentos
   */
    public searchPlanoFree(): any {
        return this.http.get(this.baseUrl + '/free');
  }

}
